import { Injectable } from '@angular/core';

import { ApiCommonService } from '@bases/services-api.base';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiAlertError } from '@core/decorators/api-alert-error';
import { KycIdentification, KycIdentificationJson } from '@models/kyc-identification.model';

@Injectable({
  providedIn: 'root'
})
export class KycIdentificationApiService extends ApiCommonService<KycIdentification, KycIdentificationJson> {
  readonly resourceUrl = 'api/v1/legal/user_validation/companies';

  fromJson(json: KycIdentificationJson): KycIdentification {
    return KycIdentification.fromJson(json);
  }

  toJson(model: KycIdentification): KycIdentificationJson {
    return KycIdentification.toJson(model);
  }

  @ApiAlertError()
  getKycIdentification(): Observable<KycIdentification> {
    const url = `${this.resourceUrl}/{companyId}/formality/{formalityId}/kyc_identification`;
    return this.httpClient
      .get<KycIdentificationJson>(url)
      .pipe(map((json: KycIdentificationJson) => this.fromJson(json)));
  }

  @ApiAlertError()
  finalizeKyc(): Observable<void> {
    const url = `${this.resourceUrl}/{companyId}/formality/{formalityId}/kyc_finalization`;
    return this.httpClient.post<void>(url, {});
  }
}
